// This hook eliminate running useEffect twice in strict mode.
// more info: https://stackoverflow.com/questions/72238175/why-useeffect-running-twice-and-how-to-handle-it-well-in-react

// inspired by https://www.30secondsofcode.org/react/s/use-effect-once/
// alternative without useRef https://stackoverflow.com/a/76617150/1614237

import {DependencyList, EffectCallback, useEffect, useRef} from "react";

/**
 * Run an effect only once, when the component mounts.
 * In strict mode useEffect runs twice, this hook is a solution for that.
 */
const useEffectOnce = (
  callback: EffectCallback,
  when: DependencyList | undefined,
) => {
  const hasRunOnce = useRef(false);

  // The callback is held in a ref rather than depended on: this hook exists to
  // run exactly once, so a new callback identity must not re-trigger it.
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (when && !hasRunOnce.current) {
      callbackRef.current();
      hasRunOnce.current = true;
    }
  }, [when]);
};

export default useEffectOnce;
